module.exports = __webpack_public_path__ + "img/saleWhite.de08aec4.svg";